/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { Switch, FormControlLabel } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { green } from "@mui/material/colors";
import DataTable from "react-data-table-component";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import moment from "moment-business-days";
import { Button, UncontrolledTooltip } from "reactstrap";
import { Copy, Edit, Trash2, Download } from "react-feather";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import { LabSelect } from "../../components/course/select";
import { humanDateFormat } from "../../../config/constants";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";
import useFetcher from "../../hooks/useFetcher";
import usePaging from "../../hooks/usePaging";
import { handleErrors } from "../../services/handleErrors";
import PopupDelete from "../../components/course/deletePopUp";
import { getCourses, updateCourse, getLabCategories, copyCourse, deleteCourse, exportCourses, exportCourseById } from "../../services/labServices";

function getItemById(array, id, property) {
  const foundItem = array.find((item) => item.id === id);

  if (foundItem) {
    return foundItem[property];
  }
  return null;
}

export function getTipo(enrrollmentType, enrrollmentsOptions) {
  const tipo = enrrollmentsOptions && enrrollmentsOptions.find((enrrollment) => enrrollment.text === enrrollmentType);
  return (tipo && tipo.spanish) || null;
}

function translateStatus(status) {
  const statusMap = {
    Active: "Activo",
    Draft: "Borrador",
    Inactive: "Inactivo",
  };

  return statusMap[status] || "Inactivo";
}
const Courses = ({ history, location }) => {
  const { currentUser } = useAuth();
  const isAudit = currentUser.haveAuditAccess(modulos.LAB);

  const [categories, isLoadingCategories] = useFetcher(getLabCategories, undefined);
  const categoryCategories = categories && categories.categories;
  const levelsCategories = categories && categories.levels;
  const [deleteCoursePopUp, setDeleteCoursePopUp] = useState(false);
  const [courseInfo, setCourseInfo] = useState({});
  const pagingController = usePaging(getCourses);

  // const [checkedStatus, setCheckedStatus] = useState(false);
  const [activedFilters, setActivedFilters] = useState(0);

  const GreenSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: green[700],
      "&:hover": {
        backgroundColor: alpha(green[700], theme.palette.action.hoverOpacity),
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: green[700],
    },
  }));

  const audienceOptions = categories.audience
    ? categories.audience
        .map((p) => {
          return { label: p.text, value: p.text };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];
  const categoriesOptions = categories.categories
    ? categories.categories
        .map((c) => {
          return { label: c.category, value: c.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];
  const levelsOptions = categories.levels
    ? categories.levels
        .map((c) => {
          return { label: c.level, value: c.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const statusOptions = [
    { label: "Activo", value: "Active" },
    { label: "Inactivo", value: "Inactive" },
  ];

  if (activedFilters < 0) {
    setActivedFilters(0);
  }

  const handleReactSelectChange = (selected, options) => {
    if ((options.action === "select-option" && options.option === undefined) || (options.action === "clear" && options.removedValues.length === 1)) {
      const newState = { [options.name]: selected ? selected.value : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    } else {
      const newState = { [options.name]: selected[0] ? selected.map((item) => item.value).join(",") : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    }
  };

  // toggle de status
  const handleStatusToogleChange = async (row) => {
    const { id, status } = row;
    const newStatus = status === "Active" ? "Inactive" : "Active";
    try {
      await updateCourse(id, {
        status: newStatus,
      });
      pagingController.reloadData(history.location);
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  const handleRowClicked = (row) => {
    // eslint-disable-next-line no-console
    console.log("row clicked", row);
  };

  const handleClickEditCourse = (row) => {
    history.push({
      pathname: `/courses/new/${row.id}`,
      state: { course: row, from: location },
    });
  };

  const handleClickDeleteCourse = async (row) => {
    const { enrolleds } = row;

    if (!enrolleds || !enrolleds.length) {
      setDeleteCoursePopUp(!deleteCoursePopUp);
      setCourseInfo(row);
    } else {
      toast.error("No se puede eliminar el curso porque tiene alumnos(s) inscrito(s)");
    }
  };

  const handleDeleteCourse = async (id) => {
    try {
      const { message, result } = await deleteCourse(id);
      if (result.id) {
        toast.success(message);
      }
      pagingController.reloadData(history.location);
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  const handleClickCopyCourse = async (row) => {
    const { id } = row;

    try {
      const { result, message } = await copyCourse(id);
      if (result.id) {
        history.push({
          pathname: `/courses/new/${result.id}`,
          state: { course: row, from: location },
        });
        toast.success(message);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  // BOTON EXPORTAR
  const downloadCSV = async () => {
    toast.success("Su solicitud de exportación esta siendo procesada");
    const link = document.createElement("a");
    const csv = await exportCourses(location.search);
    const filename = `Lab courses-${moment().format(humanDateFormat)}.csv`;
    link.setAttribute("href", `data:text/csv;charset=utf-8,${encodeURI(`sep=,\n${csv}`)}`);
    link.setAttribute("download", filename);
    link.click();
  };

  // EXPORTAR ENROLLEMENTS DE UN CURSO
  const downloadCourse = async (row) => {
    toast.success("Su solicitud de exportación esta siendo procesada");
    const link = document.createElement("a");
    const csv = await exportCourseById(row.id);
    const filename = `LAB-${row.labId}.csv`;
    link.setAttribute("href", `data:text/csv;charset=utf-8,${encodeURI(`sep=,\n${csv}`)}`);
    link.setAttribute("download", filename);
    link.click();
  };

  return (
    <>
      <Helmet>
        <title>PIN - Back Office Lab</title>
      </Helmet>
      <Breadcrumb title="Cursos" parent="Back Office lab" backButton={pagingController.query.mode === "creador"} />
      <PopupDelete
        isOpen={deleteCoursePopUp}
        toggle={() => setDeleteCoursePopUp(!deleteCoursePopUp)}
        elementToDelete={courseInfo}
        type="course"
        handleDelete={handleDeleteCourse}
      />
      <BlurSpinner isLoading={pagingController.isLoading || isLoadingCategories}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <LabSelect
                          isMulti
                          id="audience"
                          name="audience"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={audienceOptions.filter((option) => (pagingController.query.audience ? pagingController.query.audience.includes(option.value) : ""))}
                          placeholder="Público"
                          isClearable
                          isLoading={isLoadingCategories}
                          isDisabled={isLoadingCategories}
                          options={audienceOptions}
                        />
                      </div>
                    </div>

                    <div className="col-sm-2">
                      <div className="form-group">
                        <LabSelect
                          isMulti
                          id="category"
                          name="category"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={categoriesOptions.filter((option) =>
                            pagingController.query.category ? pagingController.query.category.split(",").map(Number).includes(option.value) : ""
                          )}
                          placeholder="Categoria"
                          isClearable
                          isLoading={isLoadingCategories}
                          disabled={isLoadingCategories}
                          options={categoriesOptions}
                        />
                      </div>
                    </div>

                    <div className="col-sm-2">
                      <div className="form-group">
                        <LabSelect
                          // isMulti
                          id="level"
                          name="level"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={levelsOptions.filter((option) => (pagingController.query.level ? pagingController.query.level.includes(option.value) : ""))}
                          placeholder="Nivel"
                          isClearable
                          isLoading={isLoadingCategories}
                          disabled={isLoadingCategories}
                          options={levelsOptions}
                        />
                      </div>
                    </div>

                    <div className="col-sm-2">
                      <div className="form-group">
                        <LabSelect
                          // isMulti
                          id="status"
                          name="status"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={statusOptions.filter((option) => (pagingController.query.status ? pagingController.query.status.includes(option.value) : ""))}
                          placeholder="Estado"
                          isClearable
                          isLoading={isLoadingCategories}
                          disabled={isLoadingCategories}
                          options={statusOptions}
                        />
                      </div>
                    </div>

                    <div className="d-flex col-4 justify-content-end align-items-center">
                      <div className="form-group mr-2">
                        {pagingController.totalRows > 0 && (
                          <button className="btn" type="button" onClick={(e) => downloadCSV(e.target.value)}>
                            Exportar
                          </button>
                        )}
                      </div>

                      <div className="form-group">
                        {!isAudit && (
                          <button type="button" className="btn btn-success" onClick={() => history.push("/courses/new")}>
                            Nuevo Curso
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive support-table">
                    <DataTable
                      paginationComponentOptions={{ rowsPerPageText: "Notas por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todos" }}
                      noDataComponent={
                        <div className="p-3">
                          <b>No se encontraron Cursos</b>
                        </div>
                      }
                      striped
                      pagination
                      sortServer
                      paginationServer
                      onRowClicked={handleRowClicked}
                      data={pagingController.data}
                      onSort={pagingController.handleSortsChange}
                      paginationTotalRows={pagingController.totalRows}
                      paginationDefaultPage={parseInt(pagingController.query.page || 1, 10)}
                      onChangeRowsPerPage={pagingController.handleRecordsPerPageChange}
                      paginationPerPage={parseInt(pagingController.query.perpage || 10, 10)}
                      onChangePage={pagingController.handlePageChange}
                      columns={[
                        {
                          name: "Id",
                          id: "id",
                          sortable: true,
                          selector: (row) => (row.labId ? row.labId : "-"),
                          width: "100px",
                          // style: {
                          //   display: "flex",
                          //   justifyContent: "flex-start",
                          // },
                          center: true,
                        },
                        {
                          name: "Curso",
                          id: "title",
                          selector: (row) => (row.title ? row.title : "-"),
                          sortable: true,
                          // style: {
                          //   display: "flex",
                          //   justifyContent: "flex-start",
                          // },
                          center: true,
                          //   width: "70px",
                        },
                        {
                          name: "Categoria",
                          selector: (row) => (row.category && categoryCategories ? getItemById(categoryCategories, row.category, "category") : "-"),
                          sortable: true,
                          center: true,
                          id: "category",
                          style: {
                            // cursor: "pointer",
                            textAlign: "center",
                            // display: "flex",
                            // justifyContent: "flex-start",
                          },
                        },
                        {
                          name: "Tipo",
                          selector: (row) => (row.enrollment_requirement ? getTipo(row.enrollment_requirement, categories.enrollment_requirement) : "-"),
                          sortable: true,
                          id: "enrollment_requirement",
                          center: true,
                          // style: {
                          //   display: "flex",
                          //   justifyContent: "flex-start",
                          // },
                        },
                        {
                          name: "Nivel",
                          selector: (row) => (row.category && levelsCategories ? getItemById(levelsCategories, row.level, "level") : "-"),
                          sortable: true,
                          id: "level",
                          center: true,
                          style: {
                            textAlign: "center",
                          },
                        },
                        {
                          name: "Ultima modificación",
                          selector: (row) => (row.updatedAt ? moment(row.updatedAt).format("DD/MM/YYYY") : "-"),
                          sortable: true,
                          id: "updatedAt",
                          center: true,
                          wrap: true,
                        },
                        {
                          name: "Estado",
                          selector: (row) => (
                            <div className="d-flex justify-content-between align-items-center" style={{ width: "130px" }}>
                              <div className="text-center">{row.status ? translateStatus(row.status) : "-"}</div>
                              {(row.status && row.status === "Active") || (row.status && row.status === "Inactive") ? (
                                <FormControlLabel
                                  className="mb-0"
                                  control={
                                    <GreenSwitch
                                      color="warning"
                                      value="AE"
                                      checked={row.status && row.status === "Active"}
                                      onChange={() => handleStatusToogleChange(row)}
                                      disabled={isAudit}
                                    />
                                  }
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          ),
                          sortable: true,
                          id: "status",
                          center: true,
                          width: "140px",
                        },
                        {
                          name: "Acciones",
                          //   id: "",
                          selector: (row) => (
                            <>
                              <div>
                                <UncontrolledTooltip target="btnEdit">Editar curso</UncontrolledTooltip>
                                <Button size="xs" id="btnEdit" color="link" onClick={() => handleClickEditCourse(row)} disabled={isAudit}>
                                  <Edit size="14" color="black" />
                                </Button>

                                {row.enrolleds ? (
                                  <>
                                    <UncontrolledTooltip target="btnDeleteEnrolleds"> Tiene inscriptos, solo es posible deshabilitarlo</UncontrolledTooltip>
                                    <div id="btnDeleteEnrolleds" style={{ display: "inline-block" }}>
                                      <Button size="xs" color="link" disabled>
                                        <Trash2 size="14" color="black" />
                                      </Button>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <UncontrolledTooltip target="btnDelete">Eliminar curso</UncontrolledTooltip>
                                    <Button size="xs" id="btnDelete" color="link" onClick={() => handleClickDeleteCourse(row)} disabled={isAudit}>
                                      <Trash2 size="14" color="black" />
                                    </Button>
                                  </>
                                )}

                                <UncontrolledTooltip target="btnCopy">Clonar curso</UncontrolledTooltip>
                                <Button size="xs" id="btnCopy" color="link" onClick={() => handleClickCopyCourse(row)} disabled={isAudit}>
                                  <Copy size="14" color="black" />
                                </Button>

                                <Button size="xs" id="btnDownload" color="link" onClick={() => downloadCourse(row)}>
                                  <Download size="14" color="black" />
                                </Button>
                              </div>
                            </>
                          ),
                          // sortable: true,
                          center: true,
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                            width: "115px",
                          },
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(Courses);
